import Mock from './mock';

import './db/auth';
import './db/ecommerce';
import './db/notification';

console.log("Mock.onAny().passThrough();");
Mock.onAny().passThrough();
